import React, { useContext, useState, useEffect } from "react";
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import DetalhesProduto from './DetalhesProduto';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { MyContext } from '../../../context/MyContext';
import { BrowserView, MobileView } from 'react-device-detect';


const styleDesktop = {
  position: 'absolute',
  top: '10%',
  left: '10%',
  right: "10%",
  overflow: 'scroll',
  height: '100%',
  display: 'block',
  bgcolor: 'background.paper',
  boxShadow: 24
};

const styleMobile = {
  position: 'absolute',
  top: '10%',
  left: '5%',
  right: "5%",
  overflow: 'scroll',
  height: '100%',
  display: 'block',
  bgcolor: 'background.paper',
  boxShadow: 24
};

export default function ModalDetalhes(props) {
  const { showModalDetalhes, setShowModalDetalhes } = useContext(MyContext);
  const {openMD, setOpenMD} = useContext(MyContext);

  console.log("JOAO ",props);

  const produto = Object.values(props)[0];


  console.log("JOAO II ",props);

  const handleOpen = () => {
    setShowModalDetalhes(true);
    setOpenMD(true);
  }

  const handleClose = () => {
    setShowModalDetalhes(false);
    setOpenMD(false);
  }
  
  return (    
      <div>
        <BrowserView>
        <Modal        
        open={openMD}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleDesktop}>
          <DetalhesProduto props={produto} />          
        </Box>
      </Modal>
      </BrowserView>

      <MobileView>
      <Modal        
        open={openMD}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleMobile}>
          <DetalhesProduto props={produto} />          
        </Box>
      </Modal>
      </MobileView>



      </div>
  );
}